import React, { useState, useRef, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import CustomToast from '../../components/toast/toast.jsx';

// 베트남 동 통화로 변환하는 함수
function formatMoney(amount) {
    return new Intl.NumberFormat('vi-VN', {
        style    : 'currency',
        currency : 'VND',
    }).format(amount).replace(/[₫]/g,'').trim(); // 통화 기호만 제거
};

const Acct_001_01 = ({ showModal, handleClose,BranchCodeOptions,BankCodeOptions, DetailData }) => {
    const { t }                     = useTranslation();
    const navigate                  = useNavigate ();

    const [loading, setLoading]     = useState(false);

    // 수정여부 체크(값이 존재하는 경우는 true , 값이 null , undefinded, 빈문자열은 false )
    const isEditMode   = !!DetailData;

    const selectedData = DetailData;

    const initBranchCode    = showModal ? (isEditMode ? selectedData.branch_code : BranchCodeOptions[0][0]) : [];
    const initBankid        = showModal ? (isEditMode ? selectedData.bank_id : BankCodeOptions[0][0]) : [];
    const initAccountNo     = isEditMode ? selectedData.account_no : '';
    const initBalanceAmount = isEditMode ? selectedData.balance_amount : '0';
    const initRemark        = isEditMode ? selectedData.remark : '';
    
	const [BranchCode, setBranchCode]        = useState(initBranchCode);
    const [BankId, setBankId]                = useState(initBankid);   
    const [AcctNo, setAcctNo]                = useState(initAccountNo);
	const [Balance_amount, setBalanceAmount] = useState(initBalanceAmount);
	const [Remark, setRemark]                = useState(initRemark);

    // 토스트
	const [toast, setToast]                  = useState(false);
	const [text, setText]                    = useState('');

    useEffect(() => {
        if (showModal) {
            if (isEditMode) {
                // 수정 모드인 경우 selectedData 값으로 초기화
                if (BranchCode !== selectedData.branch_code) setBranchCode(selectedData.branch_code);
                if (BankId !== selectedData.bank_id) setBankId(selectedData.bank_id);
                if (AcctNo !== selectedData.account_no) setAcctNo(selectedData.account_no);
                if (Balance_amount !== selectedData.balance_amount) setBalanceAmount(formatMoney(selectedData.balance_amount));
                if (Remark !== selectedData.remark) setRemark(selectedData.remark);
            } else {
                // isEditMode가 false인 경우 초기 값으로 설정
                setBranchCode(initBranchCode);
                setBankId(initBankid);
                setAcctNo(initAccountNo);
                setBalanceAmount(initBalanceAmount);
                setRemark(initRemark);
            }
        }
    }, [showModal, isEditMode, initBranchCode, initBankid, initAccountNo, initBalanceAmount, initRemark, selectedData]);

    // 계좌번호 정규식 (숫자와 - 만 허용)
    const allowAcctRegex = (input) => {
        const regex = /^[\d-]*$/;
        return input.match(regex) ? input : '';
    };

    // 지점
    const handleChangeBranch= (e) => {
        setBranchCode(e.target.value)
    };

    // 은행
	const handleChangeBankId = (e) => {
		setBankId(e.target.value);
	};

    // 계좌번호
	const handleChangeAcctNo = (e) => {
        const inputValue    = e.target.value;
		const filteredValue = allowAcctRegex(inputValue);

		setAcctNo(filteredValue);
	};

    // 잔액
	const handleChangeBalanceAmount = (e) => {
		setBalanceAmount(e.target.value);
	};
    // 비고
	const handleChangeRemark = (e) => {
		setRemark(e.target.value);
	};

    // 계좌 상태 조회
    const handleCheckAccount = async () => {
        // 은행이 PVCOMBANK가 아닌 경우
        if (BankId !== "99999") {
            alert('잘못된 은행 ID, 99999(PVCOMBANK) 만 지원함.');
            return;
        };

        // 계좌번호가 비어있는 경우
        if (!AcctNo) {
            alert('Account number is empty.');
            return;
        };

        setLoading(true);

		// API 호출 부분
		try {
			const data = await API.bankGetAccount();
            console.log(data)

			if (data.ok !== true) {
				alert(data.message);
				setLoading(false);
				return;
			} else {
                // 입력한 계좌번호 값과 전달 받은 모계좌의 계좌번호가 다른 경우
                if (data.account !== AcctNo) {
                    alert('Account is not matched.');
                    setBalanceAmount('0');
                    setLoading(false);
                    return;
                };
                
                setBalanceAmount(formatMoney(data.balance));
                setLoading(false);
			};
	
		} catch (error) {
			console.error('Error in fetchAcctDataUpdateState:', error);
			setLoading(false);
		}
	};
    
    // 데이터 저장시에 useRef 를 통해서 
    const formRef = useRef(null);

    // 저장 액션
    const handleSave = async (e) => {
        e.preventDefault();

        // 계좌번호가 비어있는 경우
        if (!AcctNo) {
            alert('Account number is empty.');
            return;
        };

        try {
            // 여기서 fetchAcct001DataPost 호출하고 싶다면 아래와 같이 추가할 수 있습니다.
            const savedData = await API.fetchAcct001DataPost({
                "Branch_code"    : BranchCode,
                "Bank_code"      : BankId,
                "Acct_no"        : AcctNo,
                "Balance_amount" : Balance_amount,
                "Remark"         : Remark,
            });

            // 수정 성공
            if (savedData.code === 200) {
                setText("모계좌가 수정되었습니다.");

				setToast(true);

                // 토스트가 나온 후 2초 뒤에 새로고침
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            };

            // 저장 성공
            if (savedData.code === 201) {
                setText("모계좌가 등록되었습니다.");

				setToast(true);

                // 토스트가 나온 후 2초 뒤에 새로고침
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            };
        } catch (error) {
            console.error('모계좌 정보 저장 에러:', error);
        }
    
        try {
            // 수동으로 폼 제출
            formRef.current.submit();
        } catch (error) {
            console.error('수동으로 폼 제출 에러:', error);
            // 폼 제출이 실패했을 때 수행할 로직을 추가하면 됩니다.
        }
    };

    return (
        <>
        <CustomToast show={toast} setToast={setToast} text={text} />
        <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{t('COLLECTION_MANAGEMENT.계좌등록', { defaultValue: '계좌등록' })}</Modal.Title>
            </Modal.Header>

            {/* 로딩 관련 gif */}
            {loading && 
                <div
                    style={{
                        position: 'fixed',
                        top: '50%',
                        left: '55%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 9999,
                    }}
                >
                    <img src={loader} alt="Loading..." />
                </div>
            }

            <Modal.Body className="text-start">
                <div className="row gx-4">
                    <div className="col-lg-12">
                        <div className="card border-1 mb-4">
                            <div className="card-body fw-bold">
                                {/* ref={formRef}를 사용하여 formRef가 form 엘리먼트를 참조하도록 설정. 
                                그리고 handleSave 함수에서는 이 formRef를 사용하여 submit 메소드를 호출 */}
                                <form ref={formRef} onSubmit={handleSave}>
                                    <div className="form-group mb-0">
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="branch_code_id">{t('COLLECTION_MANAGEMENT.지점', { defaultValue: '지점' })}</label>
                                            <select
                                                className="form-select"
                                                id="branch_code_id"
                                                onChange={handleChangeBranch}
                                                value={BranchCode}
                                            >
                                                {BranchCodeOptions.map((option, index) => (
                                                    <option key={index} value={option[0]}>
                                                        {option[1]}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="bank_id">{t('COLLECTION_MANAGEMENT.은행', { defaultValue: '은행' })}</label>
                                            <select
                                                className="form-select"
                                                id="bank_id"
                                                onChange={handleChangeBankId}
                                                value={BankId}
                                            >
                                                {BankCodeOptions.map((option, index) => (
                                                    <option key={index} value={option[0]}>
                                                        {option[1]}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
    
                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="acct_no_id">{t('COLLECTION_MANAGEMENT.계좌번호', { defaultValue: '계좌번호' })} <span className="text-danger">*</span></label>
                                            {/* Input 그룹 설정 */}
                                            <div className='input-group'> 
                                                <input className="form-control" type="text" id="acct_no_id" value={AcctNo}  onChange={handleChangeAcctNo}  />
                                                <div className='input-group-append'>
                                                    <button className='btn btn-outline-secondary'type='button' onClick={handleCheckAccount}>
                                                        {t(`COLLECTION_MANAGEMENT.상태조회`, { defaultValue: '상태조회' })}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="balance_id">{t('COLLECTION_MANAGEMENT.잔액', { defaultValue: '잔액' })}</label>
                                            <input className="form-control" type="text" id="balance_id" value={Balance_amount}  onChange={handleChangeBalanceAmount} style={{ textAlign: 'right' }} readOnly/>
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label" htmlFor="remark_id">{t('COLLECTION_MANAGEMENT.비고', { defaultValue: '비고' })}</label>
                                            <input className="form-control" type="text" id="remark_id"  value={Remark} onChange={handleChangeRemark}  />
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="card-footer">
                                <button className="btn btn-outline-success float-end mt-1 mb-1 me-1 ms-auto w-auto" onClick={handleSave}>{t('COMMON.저장', { defaultValue: '저장' })} <i className="fa fa-sign-in"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="d-block">
                <button className="btn btn-outline-gray me-1 mb-1 w-auto" onClick={handleClose}>
                    <i className="fa fa-backward"></i> {t('COMMON.이전', { defaultValue: '이전' })}
                </button>
            </Modal.Footer>
        </Modal>
        </>
    );
}

export default Acct_001_01;